var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBatteryDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 14.5c0-.41.34-.75.75-.75.59 0 .72-.09.73-.09.02-.06.02-.41.02-.66v-2c0-.25 0-.59-.04-.68-.01.01-.16-.07-.71-.07-.41 0-.75-.34-.75-.75s.34-.75.75-.75c2.08 0 2.25 1.02 2.25 2.25v2c0 1.23-.17 2.25-2.25 2.25-.41 0-.75-.34-.75-.75zM3.6 22.13a.736.736 0 0 1-.23-1.03l12-19c.22-.35.69-.45 1.03-.23.35.22.46.68.23 1.03l-12 19c-.14.23-.38.35-.63.35-.14 0-.28-.04-.4-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31 19.67c-3.4-.38-4.06-2.36-4.06-5.67v-4c0-4.41 1.34-5.75 5.75-5.75.41 0 .75.34.75.75s-.34.75-.75.75c-3.57 0-4.25.68-4.25 4.25v4c0 3.32.68 3.95 2.72 4.18.41.05.71.42.66.83-.04.38-.37.66-.74.66h-.08zM12.25 19c0-.41.34-.75.75-.75 3.57 0 4.25-.68 4.25-4.25v-4c0-3.31-.68-3.95-2.71-4.18a.751.751 0 0 1-.66-.83c.05-.41.41-.72.83-.66 3.38.38 4.04 2.37 4.04 5.67v4c0 4.41-1.34 5.75-5.75 5.75-.41 0-.75-.34-.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBatteryDisable);
export default __webpack_public_path__ + "static/media/vuesax-outline-battery-disable.8402c098e8b558a2adb911ef9de69189.svg";
export { ForwardRef as ReactComponent };